import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "sliderRef",
      staticClass: "b-swiper preview-cases-slider",
      attrs: { "data-qa": "preview-cases-slider" },
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "b-swiper__track",
        attrs: { "data-qa": "preview-cases-slider_track" },
      },
      [
        _vm._l(_vm.doctorCases, function (doctorCase, index) {
          return _c(
            "div",
            {
              key: index,
              ref: "slidesRef",
              refInFor: true,
              staticClass: "b-swiper__slide preview-cases-slider__slide",
              attrs: { "data-qa": "preview-cases-slider_slide" },
              on: {
                click: function ($event) {
                  return _setup.emitClickSlide(doctorCase)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "preview-cases-slider__image-preview-wrapper mb-4",
                },
                _vm._l(Math.min(doctorCase.count_images, 3), function (i) {
                  return _c("img", {
                    key: i,
                    staticClass: "preview-cases-slider__image-preview",
                    attrs: {
                      src: doctorCase.photo_preview_path,
                      alt: `${_vm.$t("Фото до и после", {
                        ns: _vm.$i18next.language,
                      })} - ${index + 1}`,
                      width: "140",
                      height: "140",
                      "data-qa": "preview-cases-slider_slide_image",
                      "aria-grabbed": "false",
                      draggable: "false",
                    },
                  })
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "preview-cases-slider__price text-subtitle-2",
                  attrs: { "data-qa": "preview-cases-slider_slide_price" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.getFormattedPrice(doctorCase.total_price)) +
                      "\n      "
                  ),
                ]
              ),
            ]
          )
        }),
        _vm._v(" "),
        _vm.doctorCaseCount > 10
          ? _c(
              "div",
              {
                ref: "slideMoreRef",
                staticClass: "b-swiper__slide preview-cases-slider__slide-more",
                attrs: { "data-qa": "preview-cases-slider_slide_more" },
              },
              [
                _c(
                  VBtn,
                  {
                    staticClass: "px-2",
                    attrs: { color: "primary", text: "", depressed: "" },
                    on: { click: _setup.emitClickSlide },
                  },
                  [
                    _c("span", { staticClass: "text-button mr-2" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("Смотреть все", {
                              ns: _vm.$i18next.language,
                            })
                          ) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "ui-icon-arrow-right" }),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      2
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }